import React from 'react';

import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

function ReminderDialog(props) {
  const isOpen = props.isOpen;

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={!!props.onClose ? props.onClose : null}
    >
      <DialogTitle id="alert-dialog-title">
        Important Note
      </DialogTitle>
      <DialogContent style={{fontSize: 15}}>
        This system is <b>not applicable for replacement of malfunctioned student identity cards without any visible damage</b>. If your card malfunctioned, please bring along the card to <a href={props.officeUrl} target="_blank">{props.officeCentre}</a> for assistance.
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReminderDialog;
